import { useRef, useCallback, useEffect } from 'react';
let globalChangeObservers = []; // store callbacks for global change events subscriptions.
// Often components need a very simple change observer.
// The eventSink would be overkill and this cleans up everything neatly on unmounts, etc.
export default function useSimpleChangeObserver(global = false) {
    const changeObservers = useRef(global ? globalChangeObservers : []); // store callbacks for change events subscriptions.
    let isUnmounted = useRef(false);
    useEffect(() => () => (isUnmounted.current = true), []);
    const onChange = useCallback(function onChange(func) {
        if (typeof func !== 'function') {
            throw new Error('useSimpleChangeObserver.onChange must be passed a function.');
        }
        changeObservers.current.push(func);
        // unsubscribe
        return () => {
            changeObservers.current.splice(changeObservers.current.indexOf(func), 1);
        };
    }, []);

    const publishChange = useCallback(function publishChange(type, entry) {
        changeObservers.current.forEach(func => {
            if (isUnmounted.current) return;
            func(type, entry);
        });
    }, []);

    return { onChange, publishChange };
}

// allow global change events to be triggered from non-react component/hooks code
// E.g. if the rules engine updates a value in bbState, it can call this to trigger
// a rerender of the appropriate parts of the UI that are subscribed through the useSimpleChangeObserver hook.
export function publishGlobalChangeDirect(type, entry) {
    globalChangeObservers.forEach(func => {
        func(type, entry);
    });
}
